module.exports = __webpack_public_path__ + "static/media/gameslash.525993ac.PNG";